import React from "react"


function Profile(){
  return (
    <div>
      profilePage
    </div>
  )
}

export default Profile